import {FormControl} from '@angular/forms';
import {UtilsService} from '../utils/utils.service';
import {Injectable, Injector} from '@angular/core';

@Injectable()
export class CustomValidators {

  constructor(private injector: Injector) {
  }

  companyCfValidator = (control: FormControl) => {
    const utils = this.injector.get(UtilsService);
    return new Promise(
      (resolve, reject) => {
        if(!control.value) {
          return resolve(null);
        }
        utils.checkCompanyCF(control.value)
          .subscribe(
            (res: any) => {
              if (res.check) {
                resolve(null);
              } else {
                const response = {};
                response[res.message] = true;
                resolve(response);
              }
            },
            err => {
              // console.log(err)
            }
          )
      }
    );
  }

  companyPiValidator = (control: FormControl) => {
    const utils = this.injector.get(UtilsService);
    return new Promise(
      (resolve, reject) => {
        if (control.value && control.value.length) {
          utils.checkCompanyPI(control.value)
            .subscribe(
              (res: any) => {
                if (res.check) {
                  resolve(null);
                } else {
                  const response = {};
                  response[res.message] = true;
                  resolve(response);
                }
              },
              err => {
                // console.log(err)
              }
            )
        } else {
          resolve(null);
        }
      }
    );
  }

  companyCfValidatorAndValues = (control: FormControl) => {
    const utils = this.injector.get(UtilsService);
    return new Promise(
      (resolve, reject) => {
        if (control.value && control.value.length) {
          utils.checkSubscriberCF(control.value)
            .subscribe(
              (res: any) => {
                if (res.check) {
                  resolve(null);
                } else {
                  const response = {};
                  response[res.message] = true;
                  resolve(response);
                }
              },
              err => {
                // console.log(err)
              }
            )
        }
      }
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/custom-validators/custom-validators.ts